/*
 * cart-fast.js — 2Tactic (theme Ecomify)
  * 1. Add To Cart nhanh: dùng Section Rendering API thay vì tải lại cả trang.
   * 2. Worry-Free Delivery (WFD) tự thêm NGAY TRONG CÙNG request Add To Cart (không tải lại giỏ lần 2),
    *    chỉ khi giỏ có sản phẩm; khách bỏ tick thì không tự thêm lại.
     * 3. Không bao giờ để giỏ chỉ có WFD: tự xoá, chặn Checkout, chặn trang /products/worry-free-delivery.
      * 4. Bấm vào "Worry-Free Delivery" trong giỏ -> popup nội dung bảo hiểm.
       * Load file này SAU product.js và cart.js.
        */
        (function () {
        var SECTION_ID = 'cart-drawer-ajax';
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var WFD = { productId: 8697122521322, variantId: 46141553443050, handle: 'worry-free-delivery' };
        var THEME_FLAG = 'ecomify-shipping-protection-init';
        var OPT_OUT = 'wfd-opt-out';
        function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
        function ls(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
        function lsSet(k, v) { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
        function isWFD(item) { return item.product_id === WFD.productId || item.variant_id === WFD.variantId || item.handle === WFD.handle; }
        function protectionEnabled() { return !!qs('[data-shipping-protection-enabled="true"]'); }
        function wfdInCartDom() { var cb = qs('#cart-shipping-protection-checkbox'); return !!(cb && cb.checked); }
        function realProductInCartDom() {
        var keys = document.querySelectorAll('#offcanvas-cart [data-line-item-key]');
        for (var i = 0; i < keys.length; i++) {
        var k = keys[i].getAttribute('data-line-item-key') || '';
        if (k && k.indexOf(String(WFD.variantId) + ':') !== 0) return true;
        }
        return false;
        }
        function shouldAutoAddWFD() { return protectionEnabled() && !ls(OPT_OUT) && !wfdInCartDom(); }
        lsSet(THEME_FLAG, 'true');
        function fetchSectionHtml() { return fetch(window.location.pathname + '?section_id=' + SECTION_ID).then(function (r) { return r.text(); }); }
        window.refreshCartContents = async function (response, prefetchedHtml) {
        var offcanvasCart = qs('#offcanvas-cart');
        var cartPage = qs('#cart');
        offcanvasCart && offcanvasCart.classList.add('loading');
        cartPage && cartPage.classList.add('loading');
        var data = null;
        if (response) { try { data = await response.clone().json(); } catch (e) {} }
        var html = prefetchedHtml || (data && data.sections && data.sections[SECTION_ID]) || null;
        if (cartPage) { html = await (await fetch(window.location.href)).text(); }
        else if (!html) { html = await fetchSectionHtml(); }
        var newDoc = new DOMParser().parseFromString(html, 'text/html');
        if (!cartPage && !(qs('.offcanvas-body', newDoc) && qs('.offcanvas-footer', newDoc))) {
        html = await (await fetch(window.location.href)).text();
        newDoc = new DOMParser().parseFromString(html, 'text/html');
        }
        if (offcanvasCart) {
        var nb = qs('#offcanvas-cart .offcanvas-body', newDoc) || qs('.offcanvas-body', newDoc);
        var nf = qs('#offcanvas-cart .offcanvas-footer', newDoc) || qs('.offcanvas-footer', newDoc);
        var ob = qs('.offcanvas-body', offcanvasCart);
        var of = qs('.offcanvas-footer', offcanvasCart);
        nb && ob && ob.replaceWith(nb);
        nf && of && of.replaceWith(nf);
        }
        if (cartPage) { var nc = qs('#cart', newDoc); nc && cartPage.replaceWith(nc); }
        var newBadge = qs('.cart-count-badge', newDoc);
        if (newBadge) { document.querySelectorAll('.cart-count-badge').forEach(function (b) { b.textContent = newBadge.textContent; b.removeAttribute('hidden'); }); }
        offcanvasCart && offcanvasCart.classList.remove('loading');
        cartPage && cartPage.classList.remove('loading');
        window.dispatchEvent(new Event('updated.ecomify.cart'));
        if (offcanvasCart && response) {
        if (response.ok) {
        if (response.url.includes('add.js')) {
        var alertAdd = qs('#offcanvas-cart-alert-add', offcanvasCart);
        alertAdd && alertAdd.removeAttribute('hidden');
        var items = ((data && data.items) || []).filter(function (i) { return !isWFD(i); });
        if (items.length > 1) {
        var el = qs('#offcanvas-cart-alert-add [data-alert-items-added]', offcanvasCart);
        if (el) { el.textContent = el.textContent.replace('[count]', items.length); el.removeAttribute('hidden'); }
        } else {
        var el1 = qs('#offcanvas-cart-alert-add [data-alert-item-added]', offcanvasCart);
        el1 && el1.removeAttribute('hidden');
        }
        } else {
        var up = qs('#offcanvas-cart-alert-updated', offcanvasCart);
        up && up.removeAttribute('hidden');
        }
        } else {
        var alert = qs('#offcanvas-cart-alert-error');
        if (alert && data) { qs('span', alert).textContent = data.message + ' - ' + data.description; alert.removeAttribute('hidden'); }
        }
        if (qs('#offcanvas-cart-empty', offcanvasCart)) { setTimeout(function () { bootstrap.Offcanvas.getOrCreateInstance(offcanvasCart).hide(); }, 1000); }
        if (qs('#cart-shipping-rates', offcanvasCart) && window.Shopify && Shopify.CountryProvinceSelector) {
        new Shopify.CountryProvinceSelector('shipping-rates-modal-country', 'shipping-rates-modal-province', { hideElement: 'shipping-rates-modal-province-wrapper' });
        }
        }
        return response;
        };
        function formToItem(form) {
        var fd = new FormData(form);
        var item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) || 1 };
        var props = {};
        var hasProps = false;
        fd.forEach(function (v, k) {
        var m = k.match(/^properties\[(.+)\]$/);
        if (m && v !== '') { props[m[1]] = v; hasProps = true; }
        });
        if (hasProps) item.properties = props;
        var sp = fd.get('selling_plan');
        if (sp) item.selling_plan = Number(sp);
        return item;
        }
        window.onSubmitAtcForm = async function (form, event) {
        event.preventDefault();
        var btn = form.querySelector('.btn-atc');
        btn.innerHTML = '<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>';
        form.classList.add('loading');
        var shouldOpenDrawer = !form.hasAttribute('data-ecomify-upsell-modal') && !btn.closest('.modal') && qs('#offcanvas-cart');
        if (shouldOpenDrawer) { qs('#offcanvas-cart').classList.add('loading'); bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show(); }
        var items = [formToItem(form)];
        if (items[0].id !== WFD.variantId && shouldAutoAddWFD()) { items.push({ id: WFD.variantId, quantity: 1 }); }
        var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: SECTION_ID, sections_url: window.location.pathname })
        });
        form.classList.remove('loading');
        btn.innerHTML = window.theme.product.addedToCart;
        setTimeout(function () { btn.innerHTML = btn.dataset.textAddToCart; }, 2000);
        window.refreshCartContents(response);
        };
        var origToggle = window.onChangeCartShippingProtection;
        if (typeof origToggle === 'function') {
        window.onChangeCartShippingProtection = function (input, event) {
        if (!input.checked) { lsSet(OPT_OUT, '1'); return origToggle.apply(this, arguments); }
        lsSet(OPT_OUT, null);
        if (!realProductInCartDom()) { input.checked = false; return; }
        return origToggle.apply(this, arguments);
        };
        }
        var autoAdding = false;
        function autoAddFallback() {
        if (autoAdding) return;
        if (!shouldAutoAddWFD()) return;
        if (!realProductInCartDom()) return;
        autoAdding = true;
        fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: WFD.variantId, quantity: 1 }] })
        }).then(function (r) { autoAdding = false; if (r.ok) window.refreshCartContents(r); }).catch(function () { autoAdding = false; });
        }
        var guarding = false;
        function guardCart(cart) {
        if (guarding) return Promise.resolve({ changed: false });
        var updates = {}, changed = false;
        var hasReal = cart.items.some(function (i) { return !isWFD(i); });
        if (cart.items.length && !hasReal) { cart.items.forEach(function (i) { updates[i.key] = 0; }); changed = true; }
        else { cart.items.forEach(function (i) { if (isWFD(i) && i.quantity > 1) { updates[i.key] = 1; changed = true; } }); }
        if (!changed) return Promise.resolve({ changed: false });
        guarding = true;
        return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function (r) { guarding = false; return { changed: true, response: r }; })
        .catch(function () { guarding = false; return { changed: false }; });
        }
        function getCart() { return fetch(root + 'cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }); }
        function guardNow() { return getCart().then(guardCart).then(function (res) { if (res.changed) window.refreshCartContents(res.response); return res; }); }
        window.addEventListener('updated.ecomify.cart', function () {
        if (qs('#offcanvas-cart-empty')) return;
        if (realProductInCartDom()) { autoAddFallback(); return; }
        guardNow();
        });
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { guardNow(); }); else guardNow();
        if (/^\/products\/worry-free-delivery(\/|$|\?)/.test(window.location.pathname)) { window.location.replace(root); }
        document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || !/\/cart\/?$/.test(form.getAttribute('action') || '')) return;
        if (!form.querySelector('[name="checkout"]')) return;
        if (form.dataset.guardOk === '1') { delete form.dataset.guardOk; return; }
        e.preventDefault();
        e.stopImmediatePropagation();
        getCart().then(function (cart) {
        var hasReal = cart.items.some(function (i) { return !isWFD(i); });
        if (cart.items.length && !hasReal) { return guardCart(cart).then(function (res) { if (res.changed) window.refreshCartContents(res.response); }); }
        form.dataset.guardOk = '1';
        var btn = form.querySelector('[name="checkout"]');
        if (btn && typeof form.requestSubmit === 'function') form.requestSubmit(btn); else form.submit();
        });
        }, true);
        var infoCache = null;
        function getInfo() {
        if (infoCache) return Promise.resolve(infoCache);
        return fetch(root + 'products/' + WFD.handle + '.js').then(function (r) { return r.json(); }).then(function (p) { infoCache = { title: p.title, html: p.description || p.body_html || '' }; return infoCache; });
        }
        function ensureModal() {
        var m = document.getElementById('wfd-info-modal');
        if (m) return m;
        m = document.createElement('div');
        m.id = 'wfd-info-modal'; m.className = 'modal fade'; m.tabIndex = -1; m.setAttribute('aria-hidden', 'true');
        m.innerHTML = '<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable"><div class="modal-content"><div class="modal-header"><h5 class="modal-title" id="wfd-info-title">Worry-Free Delivery</h5><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body rte" id="wfd-info-body"></div><div class="modal-footer"><button type="button" class="btn btn-primary w-100" data-bs-dismiss="modal">Got it</button></div></div></div>';
        document.body.appendChild(m);
        return m;
        }
        document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('#cart-shipping-protection a, a[href*="/products/worry-free-delivery"]');
        if (!a) return;
        e.preventDefault(); e.stopPropagation();
        var m = ensureModal();
        document.getElementById('wfd-info-body').innerHTML = '<p>Loading...</p>';
        getInfo().then(function (info) { document.getElementById('wfd-info-title').textContent = info.title; document.getElementById('wfd-info-body').innerHTML = info.html; });
        if (window.bootstrap && bootstrap.Modal) bootstrap.Modal.getOrCreateInstance(m).show();
        }, true);
        })();
        